import { getValue } from "firebase/remote-config";
import { remoteConfig } from "./config";

export enum RemotePrams {
  // Same keys as iOS's Remote.terms_privacy / Remote.terms_and_conditions,
  // which still read them - no longer used here, though: the web app's
  // Privacy and Terms pages (see pages/Privacy.tsx, pages/Terms.tsx) now
  // hardcode their text instead of fetching these keys, since legal copy
  // belongs under the same review/versioning as any other content in this
  // repo, not something editable from the Firebase Console without that
  // review. Kept as documented, deliberately-unused members rather than
  // deleted, since the underlying keys are still live infrastructure for
  // iOS.
  DOC_PRIVACY = "terms_privacy",
  DOC_TERMS_CONDITIONS = "terms_and_conditions",
  // Same keys the iOS app reads (Remote.limit_photos, Remote.image_upload_limit)
  // so both platforms honor whatever's published in the Firebase Console.
  LIMIT_PHOTOS = "limit_photos",
  IMAGE_UPLOAD_LIMIT_MB = "image_upload_limit",
  // Same key as iOS's Remote.cooloff_hrs_reports - hours a visitor must wait
  // before reporting the same memorial again.
  COOLOFF_HRS_REPORTS = "cooloff_hrs_reports",
  // Same key as iOS's Remote.rejection_reasons - a JSON array of
  // {title, reason} canned reasons a reviewer can quick-insert into a
  // submission review message.
  REJECTION_REASONS = "rejection_reasons",
  // How long owners are told to expect to wait for a first review response,
  // shown on the submission's in-review placeholder.
  REVIEW_RESPONSE_ETA_HOURS = "review_response_eta_hours",
  // Max number of memorials an owner can have sitting in Draft at once,
  // before "New Memorial" is blocked until one is submitted or deleted.
  DRAFT_MEMORIAL_LIMIT = "draft_memorial_limit",
  // Max number of pending (not yet accepted/declined) admin invites a
  // memorial can have out at once, before Invite is blocked until one
  // is accepted, declined, or revoked. Same pattern as the draft limit
  // above.
  PENDING_INVITE_LIMIT = "pending_invite_limit",
  // Same keys the iOS app reads (Remote.limit_funeral_max_characters,
  // Remote.limit_memorial_about_max_characters/min_characters,
  // Remote.limit_tribute_max_characters/min_characters).
  LIMIT_FUNERAL_MAX_CHARACTERS = "limit_funeral_max_characters",
  LIMIT_MEMORIAL_ABOUT_MAX_CHARACTERS = "limit_memorial_about_max_characters",
  LIMIT_MEMORIAL_ABOUT_MIN_CHARACTERS = "limit_memorial_about_min_characters",
  LIMIT_TRIBUTE_MAX_CHARACTERS = "limit_tribute_max_characters",
  LIMIT_TRIBUTE_MIN_CHARACTERS = "limit_tribute_min_characters",
  // Same {is_active, subtitle, description} shape as DOC_TERMS_CONDITIONS/
  // DOC_PRIVACY - lets the Legacy Guarantee badge's explainer copy be
  // written/edited (and staged via is_active) from the Firebase Console
  // without a redeploy, same as the legal documents.
  LEGACY_GUARANTEE = "legacy_guarantee",
}

export function getRemoteString(key: string) {
  return getValue(remoteConfig, key).asString();
}
export function getRemoteNumber(key: string) {
  return getValue(remoteConfig, key).asNumber();
}
export function getRemoteBoolean(key: string) {
  return getValue(remoteConfig, key).asBoolean();
}
export function getReviewEtaHours() {
  return getRemoteNumber(RemotePrams.REVIEW_RESPONSE_ETA_HOURS) || 48;
}

export function getRemoteJSON(key: string) {
  try {
    return JSON.parse(getValue(remoteConfig, key).asString());
  } catch (error) {
    console.error(`Error parsing JSON for config key "${key}":`, error);
    return [];
  }
}
